import axios from "axios";

import { Constants } from "../utils/constants/Constants";
import { RoutesPath } from "../routes/route-path";
import toast from "react-hot-toast";

let token = async (type) => {
  let adminUser = JSON.parse(
    localStorage.getItem(`${Constants.LOCAL_STORAGE_KEY_ADMIN_USER}`)
  );
  var idToken = "";
  if (type === "token") {
    idToken = adminUser?.token;
    if (!!idToken) {
      idToken = Constants.TEXT_TOKEN + Constants.TEXT_EMPTY + idToken;
    }
  } else {
    idToken = adminUser?.access;
    if (!!idToken) {
      idToken = Constants.TEXT_BEARER + Constants.TEXT_EMPTY + idToken;
    }
  }
  return { Authorization: idToken };
};

const redirect = (errorStatus) => {
  if (errorStatus === 401) {
    localStorage.clear();
    toast.error("Session Expired !", {
      position: "top-center",
      style: {
        backgroundColor: "#F4C3C3",
        color: "#6A2F2E",
        margin: "10px",
        fontSize: "18px",
      },
      icon: false,
    });
    setTimeout(() => {
      return (window.location.href = RoutesPath.LOGIN);
    }, 2000);
  }
};

const postCall = async (obj, url) => {
  var header = await token();
  return axios
    .post(url, obj, {
      headers: header,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response.data.message) {
        return Promise.reject(error.response.data.message);
      } else {
        return Promise.reject(error.response.statusText);
      }
    });
};
const putCall = async (obj, url) => {
  var header = await token();
  return axios
    .put(url, obj, {
      headers: header,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      redirect(error.response.status);
      if (error.response.data.message) {
        return Promise.reject(error.response.data.message);
      } else {
        return Promise.reject(error.response.statusText);
      }
    });
};
const getCall = async (url, type) => {
  var header = await token(type);
  return axios
    .get(url, {
      headers: header,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      redirect(error.response.status);
      if (error.response) {
        let e = error.response;
        return Promise.reject(e.message);
      }
    });
};
const deleteCall = async (url) => {
  var header = await token();
  return axios
    .delete(url, {
      headers: header,
    })
    .then((response) => {
      if (!response.data.result.error) {
        return response.data;
      }
    })
    .catch((error) => {
      redirect(error.response.status);
      if (error.response) {
        let e = error.response;
        return Promise.reject(e.data);
      }
    });
};
const getCallWithQuery = async (url) => {
  var header = await token();
  return axios
    .get(url, {
      headers: header,
    })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
    })
    .catch((error) => {
      redirect(error.response.status);
      if (error.response) {
        let e = error.response;
        return Promise.reject(e.data);
      }
    });
};

export default {
  postCall,
  putCall,
  getCall,
  deleteCall,
  getCallWithQuery,
};
